import SEOHead, { organizationSchema, breadcrumbSchema } from "@/components/SEOHead";
import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";
import { CtaBlock } from "@/components/FaqBlock";
import { SITE } from "@/lib/seoData";

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEOHead
        title="About BreakItDown — Built by Charlotte Bryan"
        description="BreakItDown was built by Charlotte Bryan to solve one problem: turning vague big tasks into concrete next steps. AI-powered, free, focused."
        path="/about"
        schemas={[
          organizationSchema(),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "About", path: "/about" },
          ]),
        ]}
      />
      <MarketingHeader />
      <main className="flex-1 max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16 w-full">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500 mb-3">About</p>
        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
          Built for the gap between idea and action.
        </h1>
        <p className="text-base text-zinc-600 leading-relaxed mt-6">
          BreakItDown started as a personal tool. The problem: every big task — write a proposal,
          plan a launch, organise an offsite — felt like a wall. The wall wasn't the work, it was
          knowing where to start.
        </p>
        <p className="text-base text-zinc-600 leading-relaxed mt-4">
          So we built one button: <strong>Break down</strong>. Type a fuzzy task, click the button,
          and Claude returns 4–6 specific next steps. Add a focus timer with sound cues,
          install-to-home-screen on any device, and shareable links — and you've got BreakItDown.
        </p>

        <div className="border-l-2 border-[#002FA7] bg-zinc-50 px-5 py-4 my-10">
          <p className="text-xs font-semibold uppercase tracking-[0.15em] text-zinc-500 mb-2">In short</p>
          <p className="text-sm text-zinc-800 leading-relaxed">
            BreakItDown is an opinionated, free, AI-powered task manager designed for solo work,
            ADHD productivity, and small teams. It's intentionally tiny — one feature done well.
          </p>
        </div>

        <h2 className="text-2xl font-semibold text-zinc-900 mt-12 mb-3">Founder</h2>
        <p className="text-base text-zinc-600 leading-relaxed">
          BreakItDown is built by{" "}
          <a
            href={SITE.founder.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#002FA7] underline"
          >
            Charlotte Bryan
          </a>
          . Visit her site for other work and writing.
        </p>

        <h2 className="text-2xl font-semibold text-zinc-900 mt-12 mb-3">Editorial standards</h2>
        <p className="text-base text-zinc-600 leading-relaxed">
          All comparison and use-case content is grounded in publicly available facts about
          competitor products at time of writing. Pricing changes — please verify on the
          competitor's official site. Blog posts are reviewed by the founder before publication.
        </p>

        <CtaBlock />
      </main>
      <MarketingFooter />
    </div>
  );
}
